export const onSubmitWrapper = (cb: (e: any) => void) => {
  return (e: any) => {
    e.stopPropagation();

    return cb(e);
  };
};
